import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type THeaderMenuTriggerElement,
  type THeaderMenuTriggerProps,
} from "@/ui/components/navigation/Header/Header.config";
import { cn } from "@/ui/lib/utils";

export const HeaderMenuTrigger = forwardRef<
  THeaderMenuTriggerElement,
  THeaderMenuTriggerProps
>(({
  children,
  className,
  onPointerLeave,
  onPointerMove,
  ...props
}, ref) => (
  <NavigationMenuPrimitive.Trigger
    ref={ref}
    data-component="HeaderMenuTrigger"
    className={cn(
      "h-11 w-11 outline-sys-chartreuse-600",
      className,
    )}
    onPointerLeave={(event) => {
      onPointerLeave?.(event);

      if (event.pointerType === "mouse") { event.preventDefault(); }
    }}
    onPointerMove={(event) => {
      onPointerMove?.(event);

      if (event.pointerType === "mouse") { event.preventDefault(); }
    }}
    {...props}
  >
    { children }
  </NavigationMenuPrimitive.Trigger>
));

HeaderMenuTrigger.displayName = NavigationMenuPrimitive.Trigger.displayName;
